enum CancelledReason {
    CANCELLED_REASON_UNDEFINED = 0,
    CANCELLED_REASON_CREATED_BY_MISTAKE = 1,
    CANCELLED_REASON_REQUIREMENTS_CHANGED = 2,
    CANCELLED_REASON_WORKER_NO_LONGER_AVAILABLE = 3,
    
}

export default CancelledReason;